import { Dispatch, SetStateAction } from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { useDispatch, useSelector } from 'react-redux';
import { setCancelSubConfirmMsg, selectCancelSubConfirmMsg } from 'reducers/misc';
import { SubscriptionsApi } from 'api/subscriptionsApi';
import { useNavigate } from "@reach/router";

type Props = {
  accountPackageID: number | null;
  setAccountPackageID: Dispatch<SetStateAction<number>>;
  setError: Dispatch<SetStateAction<string>>;
};

export const SubscriptionCancelMsgModal: React.FC<Props> = ({
  accountPackageID,
  setAccountPackageID,
  setError,
}) => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const openCancelMsgModal = useSelector(selectCancelSubConfirmMsg);

  const handleEnableAutoRenew = async () => {
    setError('');

    if(accountPackageID){
      const result = await SubscriptionsApi.autoRenewSubscription(accountPackageID, false);

      if (result.data) {
        if (result.data.status === "1"){
          handleClose();
          navigate("/manage-school");
        } else {
          setError('An error occurred, please try again.');
        }
      }

      if (result.error) {
        setError('An error occurred, please try again.');
      } 
    } else {
      setError('An error occurred, please try again.');
    } 
  };

  const handleClose = () => {
    setAccountPackageID(0);
    dispatch(setCancelSubConfirmMsg(false));
  };

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={openCancelMsgModal}
      hdrTitle={'Cancel Subscription'}
      position="right"
      primaryBtnTxt="Cancel Auto-Renew"
      secondaryBtnTxt="Close"
      secondaryBtnColor="BtnGrey"
      handlePrimaryBtn={() => handleEnableAutoRenew()}
      handleSecondaryBtn={() => {
        handleClose();
        navigate("/manage-school");
      }}
      givenClass="SubscriptionRenewalModal"
      handleClose={() => handleClose()}            
      width={560}
    >
      <p>Are you sure you wish to cancel your subscription? A break in your service loses your returning school discount.</p>
      <div className="LineSpacer3"></div>
    </PopupOrPanel>
  );
};
